export enum PageNames {
  Main = 'MAIN',
  Facility = 'FACILITY',
  Invaild = 'INVAILD'
}
